import React, {useState} from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faHeart} from "@fortawesome/free-regular-svg-icons";
import {faHeart as faSolidHeart} from "@fortawesome/free-solid-svg-icons";
import useLike from "../../../hooks/useLike";

const Like = ({
        isLiked = false,
        value = 0,
        likeType = null,
        parentId = null
    }) =>{

    const [count, setCount] = useState(value);

    const {isLiked : isLike, handleLike } = useLike({
        parentKind : likeType,
        parentId,
        isLike : isLiked,
        onSuccess : () =>{
            setCount(!isLike ? count +1 : count -1);
        },
        onError : () =>{
            setCount(value);
        }
    });

    return(
        <div
            className={`likes ${isLike ? 'active' : ''}  ${isLike ? 'animate-like' : ""}`}
            onClick={() => handleLike()}
        >
            <span className='like-icon'>{isLike ? ( <FontAwesomeIcon icon={faSolidHeart}/>) : (<FontAwesomeIcon icon={faHeart}/>)}</span>{count}
        </div>
    )
};

export default Like;